const currentUrl = window.location.origin;
export const navbar = `
    <nav class="w-full z-20 transition-shadow duration-1000 fixed top-0" id="navbar">
  <div class="mx-auto max-w-full px-2 sm:px-6 lg:px-8">
    <div class="relative flex h-16 items-center justify-between gap-5">
      <div class="absolute inset-y-0 left-0 flex items-center md:block lg:hidden">
        <!-- Mobile menu button-->
        
        <label for="MOBILE_DROPDOWN" class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-900 hover:bg-gray-700 hover:mt-1 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset" aria-controls="mobile-menu" aria-expanded="false">
          <span class="absolute -inset-0.5"></span>
          <span class="sr-only">Open main menu</span>
          <!--
            Icon when menu is closed.

            Menu open: "hidden", Menu closed: "block"
          -->
          <svg class="block size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
          <!--
            Icon when menu is open.

            Menu open: "block", Menu closed: "hidden"
          -->
       
        </label>
      </div>
      <div class="flex flex-1 items-center justify-between sm:items-stretch gap-5">
      <a href="/"
      aria-label="Home"
      >
        <div class="flex shrink-0 items-center hidden md:hidden lg:block">
          <img src="https://ibankeystaticstorage.blob.core.windows.net/cdnfiles/Assets/ibankylogo.png" alt ="Ibankey" class="w-36 p-2"/>
        </div>
        </a>
        <div class="hidden lg:flex rounded-full bg-[#f9f9f9]  items-center justify-center">
          
        <a href="/" 
        aria-label="Home"
        >
           <div class="flex text-nowrap items-center gap-2 rounded-md px-6 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 hover:rounded-full hover:text-gray-700">
           <div class="w-2 h-2 bg-blue-800 rounded-full"></div>
            Home
           </div>
           </a>
        <a href="./about.html" 
        aria-label="About"
        >
           <div class="flex text-nowrap items-center gap-2 rounded-md px-6 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 hover:rounded-full hover:text-gray-700">
           <div class="w-2 h-2 bg-blue-800 rounded-full"></div>
            About us
           </div>
           </a>
           <a href="./teams.html" 
           aria-label="Teams"
           >
           <div class="flex items-center gap-2 rounded-md px-6 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 hover:rounded-full hover:text-gray-700">
           <div class="w-2 h-2 bg-blue-800 rounded-full"></div>
            Team
           </div>
           </a>
           <a href="./career.html" 
           aria-label="Career"
           >
           <div class="flex items-center gap-2 rounded-md px-6 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 hover:rounded-full hover:text-gray-700">
           <div class="w-2 h-2 bg-blue-800 rounded-full"></div>
            Career
           </div>
           </a>
           <a href="#" 
           aria-label="Blog"
           >
           <div class="flex items-center gap-2 rounded-md px-6 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 hover:rounded-full hover:text-gray-700">
           <div class="w-2 h-2 bg-blue-800 rounded-full"></div>
           Blog
           </div>
           </a>
            <a href="./contact.html" 
            aria-label="Contact"
            >
           <div class="flex items-center gap-2 rounded-md px-6 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 hover:rounded-full hover:text-gray-700">
           <div class="w-2 h-2 bg-blue-800 rounded-full"></div>
            Contact
           </div>
           </a>
        </div>
      </div>
      <div class="flex items-center justify-center gap-4">
        <button
  onclick="document.getElementById('loginModal').showModal()"
  class="rounded-md px-3 py-2  text-sm font-medium text-gray-700 hover:bg-blue-100 hover:text-gray-700 cursor-pointer"
>
  Login
</button>
 <!-- Modal -->
<dialog onmousedown="this==event.target && this.close()" id="loginModal" class="w-full max-w-md p-0 border-0 bg-transparent">
  <div
    class="fixed top-16 right-0 lg:right-44 bg-white p-6 rounded-xl shadow-lg w-full lg:w-80 text-center"
  >
    <!-- Close Button -->
    <form method="dialog" class="absolute top-2 right-2">
      <button class="text-gray-500 hover:text-gray-800 text-xl cursor-pointer">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </form>

        <img
        src="https://ibankeystaticstorage.blob.core.windows.net/cdnfiles/Assets/ibankylogo.png"
        alt="ibankey"
        class="mx-auto h-5 mb-4"
      />

    <h2 class="text-lg font-semibold text-blue-600 mb-4">Log in as</h2>

    <div class="flex flex-col items-center gap-4">
      <a
      href="${currentUrl}/lender"
      aria-label="Lender"
        class="w-full flex flex-col items-center p-4 rounded-xl bg-blue-50 hover:bg-blue-100 transition"
      >
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/lenderAuth.svg"
          alt="Lender"
          class="w-10 h-10 mb-1"
        />
        <span class="text-gray-800 font-medium">Lender</span>
      </a>

      <a
      href=${currentUrl}/borrower
      aria-label="Borrower"
        class="w-full flex flex-col items-center p-4 rounded-xl bg-blue-50 hover:bg-blue-100 transition"
      >
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/borrowerAuth.svg"
          alt="Borrower"
          class="w-10 h-10 mb-1"
        />
        <span class="text-gray-800 font-medium">Borrower</span>
      </a>
      <a
      href="${currentUrl}/partner"
      aria-label="Partner"
        class="w-full flex flex-col items-center p-4 rounded-xl bg-blue-50 hover:bg-blue-100 transition"
      >
        <img
          src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/partnerAuth.svg"
          alt="Partner"
          class="w-10 h-10 mb-1"
        />
        <span class="text-gray-800 font-medium">Partner</span>
      </a>
    </div>

     <p class="mt-6 text-sm text-gray-500">
      Not Registered?
      <button onclick="document.getElementById('signupModal').showModal(); document.getElementById('loginModal').close()"
       class="text-blue-600 hover:underline cursor-pointer">Sign up</button>
    </p> 
  </div>
</dialog>

   <button
      onclick="document.getElementById('signupModal').showModal()"
      class="rounded-md px-3 py-2 cursor-pointer bg-linear-65 text-nowrap from-purple-600 to-blue-700 text-sm font-medium text-white hover:bg-gray-700 hover:text-white"
    >
      Sign up
    </button>
    <!--signup Modal -->
    <dialog
      id="signupModal"
      onmousedown="this == event.target && this.close()"
      class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg w-full max-w-4xl shadow-xl text-center p-0 border-0"
    >
      <div class="flex flex-col md:flex-row w-full">
        <!-- Left: Modal Content -->
        <div class="w-full md:w-1/2 p-6">
          <!-- Close Button -->
          <form method="dialog" class="absolute top-2 right-2">
            <button
              class="text-gray-500 hover:text-gray-800 text-2xl cursor-pointer"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </form>

          <!-- Logo -->
          <img
            src="https://ibankeystaticstorage.blob.core.windows.net/cdnfiles/Assets/ibankylogo.png"
            alt="ibankey"
            class="mx-auto h-5 mb-4"
          />

          <!-- Heading -->
          <h2 class="text-lg font-medium text-blue-600 mb-6">Sign up as</h2>

          <!-- Option Cards -->
          <div class="space-y-4">
            <a
              href="${currentUrl}/signup/#/signupBorrower"
              aria-label="signupBorrower"
              class="flex items-center gap-4 w-full px-4 py-3 rounded-2xl shadow bg-white hover:bg-gray-50"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/borrowerAuth.svg"
                alt="Borrower"
                class="w-10 h-10"
              />
              <span class="text-lg font-semibold text-gray-800">BORROWER</span>
            </a>

            <a
              href="${currentUrl}/signup/#/signupLender"
              aria-label="signupLender"
              class="flex items-center gap-4 w-full px-4 py-3 rounded-2xl shadow bg-white hover:bg-gray-50"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/lenderAuth.svg"
                alt="Lender"
                class="w-10 h-10"
              />
              <span class="text-lg font-semibold text-gray-800">LENDER</span>
            </a>

            <a
              href="${currentUrl}/signup/#/signupPartner"
              aria-label="signupPartner"
              class="flex items-center gap-4 w-full px-4 py-3 rounded-2xl shadow bg-white hover:bg-gray-50"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/partnerAuth.svg"
                alt="Partner"
                class="w-10 h-10"
              />
              <span class="text-lg font-semibold text-gray-800">PARTNER</span>
            </a>
          </div>

          <!-- Login Text -->
          <p class="mt-6 text-sm text-gray-600">
            Already Registered?
            <button
              onclick="document.getElementById('signupModal').close(); document.getElementById('loginModal').showModal()"
              class="text-blue-600 hover:underline cursor-pointer"
            >
              Login Here
            </button>
          </p>
        </div>

        <!-- Right: Image -->
        <div
          class="hidden md:block md:w-1/2 bg-gray-50 rounded-r-lg overflow-hidden bg-pink-300"
        >
          <img
            src="https://ibankey.com/assets/signUpMainImage-rKMGgYip.svg"
            alt="Sign up visual"
            class="w-full h-full object-cover"
          />
        </div>
      </div>
    </dialog>   
      </div>
      </div>
    </div>
  </div>

  <!-- Mobile menu, show/hide based on menu state. -->
  <input id="MOBILE_DROPDOWN" type="checkbox" class="mobile_dropdown_checkbox hidden" aria-controls="mobile-menu" aria-expanded="false"/>
  <div class=" mobile_dropdown" id="mobile-menu">
    <div class="space-y-1 px-2 pt-2 pb-3 shadow-md bg-white">
      <!-- Current: "bg-gray-900 text-white", Default: "text-gray-700 hover:bg-gray-700 hover:text-white" -->
      <a href="/"
      aria-label="Home"
      class="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white" aria-current="page">Home</a>
      <a href="./about.html"
      aria-label="About"
      class="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-700 hover:text-white">About us</a>
      <a href="./teams.html"
      aria-label="Teams"
      class="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-700 hover:text-white">Team</a>
      <a href="./career.html"
      aria-label="Career"
      class="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-700 hover:text-white">Carrer</a>
      <a href="#" 
      aria-label="Blog"
      class="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-700 hover:text-white">Blog</a>    
      <a href="./contact.html"
      aria-label="Contact"
      class="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-700 hover:text-white">Contact</a>
    </div>
  </div>
  
  <dialog
      onmousedown="this==event.target && this.close()"
      id="sme_modal"
    >
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <div
            class="relative flex transform overflow-hidden rounded-3xl border-white border-5 bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl gap-1"
          >
            <div
              class="flex flex-1/2 flex-col items-center justify-center bg-[#f3fcfb] py-2.5 px-4 lg:px-18"
            >
              <div
                class="bg-white p-6 border border-gray-100 rounded-lg shadow-md w-full max-w-md"
              >
                <p class="text-center text-xs font-semibold text-gray-600 pb-1">
                  Please provide your contact information:
                </p>
                <p
                  class="text-center text-[10px] font-semibold text-gray-600 pb-4"
                >
                  Our team will reach out to you for demo.
                </p>
                <form id="sme_form" class="space-y-3">
                  <label
                    for="companyName"
                    class="block mb-1 text-xs font-medium text-gray-900"
                    >Company Name</label
                  >
                  <div class="relative">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 52 52"
                        enable-background="new 0 0 52 52"
                        xml:space="preserve"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M21,4H7C5.3,4,4,5.3,4,7v40c0,0.5,0.5,1,1,1h4c0.6,0,1-0.4,1-1v-6c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v6 c0,0.6,0.4,1,1,1h3c1.1,0,2-0.9,2-2V7C24,5.3,22.7,4,21,4z M12,35.5c0,0.3-0.2,0.5-0.5,0.5h-3C8.2,36,8,35.8,8,35.5v-5 C8,30.2,8.2,30,8.5,30h3c0.3,0,0.5,0.2,0.5,0.5V35.5z M12,25.5c0,0.3-0.2,0.5-0.5,0.5h-3C8.2,26,8,25.8,8,25.5v-5 C8,20.2,8.2,20,8.5,20h3c0.3,0,0.5,0.2,0.5,0.5V25.5z M12,15.5c0,0.3-0.2,0.5-0.5,0.5h-3C8.2,16,8,15.8,8,15.5v-5 C8,10.2,8.2,10,8.5,10h3c0.3,0,0.5,0.2,0.5,0.5V15.5z M20,35.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V35.5z M20,25.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V25.5z M20,15.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V15.5z"
                          ></path>
                          <path
                            d="M45,14H31c-1.7,0-3,1.3-3,3v30c0,0.5,0.5,1,1,1h4c0.6,0,1-0.4,1-1v-6c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v6 c0,0.6,0.4,1,1,1h3c1.1,0,2-0.9,2-2V17C48,15.3,46.7,14,45,14z M36,35.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V35.5z M36,25.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V25.5z M44,35.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V35.5z M44,25.5c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-5 c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5V25.5z"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <input
                      type="text"
                      required
                      id="companyName"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 placeholder:italic"
                      placeholder="name pvt ltd"
                    />
                  </div>
                  <label
                    for="email"
                    class="block mb-1 text-xs font-medium text-gray-900"
                    >Your Email</label
                  >
                  <div class="relative">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 16"
                      >
                        <path
                          d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z"
                        />
                        <path
                          d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z"
                        />
                      </svg>
                    </div>
                    <input
                      type="email"
                      required
                      id="email"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 placeholder:italic"
                      placeholder="name@email.com"
                    />
                  </div>
                  <label
                    for="industry"
                    class="block mb-1 text-xs font-medium text-gray-900"
                    >Industry</label
                  >
                  <div class="relative">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
                          ></path>
                        </g>
                      </svg>
                    </div>

                        <select
                      id="industry"
                      required
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10  p-2.5 placeholder:italic"
                    >
                      <option  value="" >Select an Industry </option>
                     
                    </select>


                  </div>
                  <label
                    for="govtScheme"
                    
                    class="block mb-1 text-xs font-medium text-gray-900"
                    >Govt. Schemes
                    </label
                  >

                  <div class="relative">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 347.971 347.971"
                        xml:space="preserve"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M317.309,54.367C257.933,54.367,212.445,37.403,173.98,0C135.519,37.403,90.033,54.367,30.662,54.367 c0,97.405-20.155,236.937,143.317,293.604C337.463,291.305,317.309,151.773,317.309,54.367z M162.107,225.773l-47.749-47.756 l21.379-21.378l26.37,26.376l50.121-50.122l21.378,21.378L162.107,225.773z"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <select
                      id="govtScheme"
                      required
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10  p-2.5 placeholder:italic"
                    >
                      <option value="">Select an loan Scheme </option>
                     
                    </select>
                  </div>

                  <label
                    for="loanAmount"
                    class="block mb-1 text-xs font-medium text-gray-900"
                    >Loan Amount
                    <span class="text-gray-400">(in Cr)</span></label
                  >

                  <div class="relative">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        enable-background="new 0 0 24 24"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M17,15.5V17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.5H9V17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.5H5c-0.7,0-1.4-0.2-2-0.5v4c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3v-4c-0.6,0.3-1.3,0.5-2,0.5H17z M21,6h-4V5c0-1.7-1.3-3-3-3h-4C8.3,2,7,3.3,7,5v1H3C2.4,6,2,6.4,2,7v4c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V7C22,6.4,21.6,6,21,6z M15,6H9V5c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1V6z"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <input
                      type="number"
                      required
                      id="loanAmount"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 placeholder:italic"
                      placeholder="amount"
                    />
                  </div>


                  <label
                    for="enquire"
                    class="block mb-1 text-xs font-medium text-gray-900"
                    >Enquire</label
                  >
                  <div class="relative">
                    <div
                      class="absolute inset-y-0 start-0 flex items-start p-3.5 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M17 2H7C4.24 2 2 4.23 2 6.98V12.96V13.96C2 16.71 4.24 18.94 7 18.94H8.5C8.77 18.94 9.13 19.12 9.3 19.34L10.8 21.33C11.46 22.21 12.54 22.21 13.2 21.33L14.7 19.34C14.89 19.09 15.19 18.94 15.5 18.94H17C19.76 18.94 22 16.71 22 13.96V6.98C22 4.23 19.76 2 17 2ZM8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12ZM12 12C11.44 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.56 12 12 12ZM16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z"
                            fill="currentColor"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <textarea
                      placeholder="comments"
                      required
                      rows="3"
                      id="enquire"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 placeholder:italic"
                    ></textarea>
                  </div>
                  <label class="block mb-1 text-xs font-medium text-gray-900"
                    >Loan Type</label
                  >
                  <div class="flex items-center justify-between flex-wrap">
                    <div class="flex items-center mb-4">
                      <input
                        checked
                        id="termloan"
                        type="checkbox"
                        value="60BAB611-07F8-4788-B5D0-890DB4806D58"
                        class="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2"
                      />
                      <label
                        for="termloan"
                        class="ms-1 text-[10px] font-medium text-gray-900"
                        >Term Loan</label
                      >
                    </div>
                    <div class="flex items-center mb-4">
                      <input
                        id="supplyChainFinance"
                        value="13043B21-BA6D-4F6F-B65E-51FCE978249B"
                        type="checkbox"
                        class="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2"
                      />
                      <label
                        for="supplyChainFinance"
                        class="ms-1 text-[10px] font-medium text-gray-900"
                        >Supply Chain Finance</label
                      >
                    </div>
                    <div class="flex items-center mb-4">
                      <input
                        id="workingCapital"
                        type="checkbox"
                        value="D399D34A-8424-48E6-ACEC-6DE953DA8480"
                        class="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2"
                      />
                      <label
                        for="workingCapital"
                        class="ms-1 text-[10px] font-medium text-gray-900"
                        >Working Capital</label
                      >
                    </div>
                  </div>
                  
                  <button
                  id="sme_submit_btn"
                    type="submit"
                    class="btn bg-blue-500 cursor-pointer text-xs hover:bg-blue-400 text-white p-2 rounded-lg w-full"
                  >
                    Submit Enquiry
                  </button>
                </form>
              </div>
            </div>
            <div
              class="hidden flex-1/2 md:flex p-18 bg-stone-100 relative flex-col items-center gap-5 justify-center"
            >
              <img
                width="100"
                src="https://ibankeystaticstorage.blob.core.windows.net/cdnfiles/Assets/ibankylogo.png"
              />
              <p
                class="mt-5 text-center text-md font-semibold text-gray-700 pb-1"
              >
                iBankey & SME Chamber: Powering Business Growth Together
              </p>
              <img
                src="https://www.smechamberofindia.com/images/SME_LOGO.svg"
                alt="SME Chamber of India"
                class="w-50"
              />
              <p
                class="text-sm pt-3 text-justify font-semibold text-blue-900 underline"
              >
                Fueling the Future of Small and Medium Businesses
              </p>
              <p class="text-xs text-center font-semibold text-gray-600">
                Empowers small and medium enterprises by fostering growth,
                global partnerships, policy advocacy, and business
                transformation. It connects entrepreneurs, corporates, and
                investors to drive innovation, exports, and investment through a
                strong international network.
              </p>
              <p class="text-xs text-center py-5 font-semibold text-gray-600">
                As a member of SME Chamber of India, iBankey enables SMEs with
                smart financial solutions, easier access to funding, and growth
                opportunities through a trusted business network.
              </p>
              <form method="dialog">
                <button class="absolute cursor-pointer top-1 right-1 w-8 h-8">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        opacity="0.4"
                        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
                        fill="#a8a29e   "
                      ></path>
                      <path
                        d="M13.0594 12.0001L15.3594 9.70011C15.6494 9.41011 15.6494 8.93011 15.3594 8.64011C15.0694 8.35011 14.5894 8.35011 14.2994 8.64011L11.9994 10.9401L9.69937 8.64011C9.40937 8.35011 8.92937 8.35011 8.63938 8.64011C8.34938 8.93011 8.34938 9.41011 8.63938 9.70011L10.9394 12.0001L8.63938 14.3001C8.34938 14.5901 8.34938 15.0701 8.63938 15.3601C8.78938 15.5101 8.97937 15.5801 9.16937 15.5801C9.35937 15.5801 9.54937 15.5101 9.69937 15.3601L11.9994 13.0601L14.2994 15.3601C14.4494 15.5101 14.6394 15.5801 14.8294 15.5801C15.0194 15.5801 15.2094 15.5101 15.3594 15.3601C15.6494 15.0701 15.6494 14.5901 15.3594 14.3001L13.0594 12.0001Z"
                        fill="#f5f5f4"
                      ></path>
                    </g>
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </dialog>
    </nav>

`;
